/**
 * ClientGroup entity model — ES module version of MyScripts/Entities/ClientGroup.ts
 */

import type {
  ClientGroupData,
  ClientGroupSiteData,
  ClientAutomatedNotificationData,
  PhoneNumberData,
  EmailData,
  AttachmentData,
  WarningData,
  GateCodeData,
  ConnectionsData,
} from '@/services/api-types';

export type { ClientGroupData, ClientGroupSiteData, ClientAutomatedNotificationData };

export function createClientGroup(data?: Partial<ClientGroupData>): ClientGroupData {
  return {
    id: null,
    name: null,
    website: null,
    notes: null,
    locName: null,
    locAddress: null,
    locAddress2: null,
    locCity: null,
    locState: null,
    locZip: null,
    locCountry: null,
    locFormattedAddress: null,
    latitude: null,
    longitude: null,
    customLocationId: null,
    accountNumber: null,
    authorizationCode: null,
    notificationDefaultTimeZoneId: null,
    notificationDefaultTime: null,
    emails: [],
    descriptionPicInfoId: null,
    attachmentList: [],
    sites: [],
    automatedNotificationList: [],
    phoneNumbers: [],
    warnings: [],
    gateCodes: [],
    connections: { people: [], vehicles: [], clients: [], businesses: [], reports: [] },
    ...data,
  };
}
